import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Modal from '@components/Modal/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partName: string;
  isDeleting?: boolean;
};

export const DeletePartModal = ({
  open,
  onClose,
  onConfirm,
  partName,
  isDeleting = false
}: Props) => {
  const { t } = useTranslation(['parts', 'common']);

  return (
    <Modal open={open} onClose={onClose} maxWidth="sm">
      <Modal.Header
        title={t('parts:deletePartModal.title')}
        onClose={onClose}
      />
      <Modal.Content>
        <Typography>
          {t('parts:deletePartModal.message', { partName })}
        </Typography>
      </Modal.Content>
      <Modal.Footer
        primaryButton={{
          text: isDeleting
            ? t('parts:deletePartModal.removing')
            : t('parts:removePart'),
          color: 'error',
          variant: 'contained',
          onClick: onConfirm,
          disabled: isDeleting,
          loading: isDeleting
        }}
        secondaryButton={{
          text: t('common:buttons.cancel'),
          onClick: onClose,
          disabled: isDeleting
        }}
      />
    </Modal>
  );
};
